module.exports = __webpack_public_path__ + "static/media/181CO253.f823b91e.jpeg";